<div class="modal-body relative">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <div class="flex justify-between">
      <span class="w-[5%]"></span>
      <h2 class="modal-headline uppercase" [ngClass]="{ 'text-xl': ['Video', 'Audio'].includes(data.type) }">{{ data.header }}</h2>
      <button mat-icon-button mat-dialog-close class="button-close" (click)="data.type === 'terms' && onCancelClick()">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </header>
  <div class="flex-col gap-3 bg-white h-full">
    <div class="modal-main flex justify-between w-full !min-h-[100px]">
      <div *ngIf="data.type === 'info'" class="flex flex-col w-full max-h-[450px] overflow-scroll">
        <div class="flex" [innerHTML]="data.text"></div>
      </div>
      <div *ngIf="data.type === 'terms'" class="flex flex-col w-full max-h-[500px] overflow-scroll">
        <div class="flex flex-col">
          <p>Alle Angaben ohne Gewähr.</p>
          <br />
          <p>
            Da die Werbemittel-Produktion erstmals im Rahmen des bestehenden Agenturvertrag durch die Serviceplan Make GmbH & Co. KG abgewickelt wird, möchten wir an dieser Stelle der Sorgfaltspflicht
            halber darauf hinweisen, dass die Haftung für die Daten für die Werbemittelerstellung, die aus der Schnittstelle gezogen werden, auf Seiten des Auftraggebers liegt.
          </p>
          <br />
          <p>
            Zudem stimmen Sie mit dem Download der Werbemittel zu, für die Überprüfung der Richtigkeit der Werbemittel bezüglich der kommunizierten Jackpot-Werte und des nächsten Ziehungsdatums bzw.
            Ziehungstags zu sorgen und dass die Werbemittel nur während der Gültigkeit der Jackpot-Werte bzw. vor dem Ziehungstag/datum veröffentlicht werden. Die aktuellen Jackpot-Werte und das
            Datum/den Tag der nächsten Ziehung finden Sie unter <a href="https://www.eurojackpot.de" target="_blank" rel="noopener">https://www.eurojackpot.de</a>.
          </p>
          <br />
          <p>
            Die Serviceplan Make GmbH & Co. KG, als Bereitsteller dieser Website, übernimmt keine Haftung für den korrekten Einsatz der zur Verfügung gestellten Werbemittel durch den Nutzer. Die
            Richtigkeit der zur Verfügung gestellten Daten auf <a href="https://www.eurojackpot.de" target="_blank" rel="noopener">https://www.eurojackpot.de</a> und aus der Schnittstelle, unterliegt
            zudem dem Auftraggeber.
          </p>
        </div>
      </div>
      <div *ngIf="data.type === 'Video'" class="flex flex-col w-full overflow-scroll">
        <div class="media-asset">
          <div class="media-asset-visualizer">
            <video #video class="object-contain w-full m-auto" [src]="data.previewUrl" [poster]="previewImageUrl" preload="metadata" controls>Your browser does not support HTML video.</video>
          </div>
        </div>
      </div>
      <div *ngIf="data.type === 'Audio'" class="flex flex-col w-full max-h-[450px] overflow-scroll">
        <div class="media-asset">
          <div class="media-asset-visualizer">
            <audio [src]="data.previewUrl" controls preload="metadata"></audio>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="data.showFooter" class="modal-footer flex flex-col w-full gap-1 h-[10%] sticky bottom-0 bg-white z-50 flex-1">
    <div *ngIf="data.type === 'info'">
      <p>Mit freundlichen Grüßen,</p>
      <p>Ihr Eurojackpot-Team</p>
    </div>
    <div *ngIf="data.type === 'terms'">
      <div class="actions flex flex-row justify-end w-full mt-4 p-2">
        <button type="button" class="button-primary" mat-flat-button (click)="onAcceptClick()" i18n>I accept</button>
      </div>
    </div>
  </div>
</div>
